import { KolumnaImportuEwidencji } from "./kolumnaImportuEwidencji";

export class MapujEwidencjeModel {
    projektId: string;
    lokalizacjaKolumnaEwidencji: string;
    lokalizacjaKolumnaLokalizacja: string;
    kolumnyImportu: Array<KolumnaImportuEwidencji> = new Array();
}